import { elementsExistFunction } from '@/utils/lazy-init';

export default function () {
    elementsExistFunction([
        /* nav-search-field is in the bundle, but it is not loaded because the element is present
           instead it is loaaded from SearchButton in navigation on button click */
        '[app="search-list-component"]',
        '[app="search-page-component"]',
    ], () => import('./index.search.lazy').then(x => x.initComponents()));
}